import { render, staticRenderFns } from "./MagazzinoMagazziniListPage.vue?vue&type=template&id=23dc54e7"
import script from "./MagazzinoMagazziniListPage.vue?vue&type=script&lang=js"
export * from "./MagazzinoMagazziniListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports